<template>
    <div class="developmentDetatil">
        <div class="Con-developmentDetatil">
            <el-breadcrumb class="tip" separator-class="el-icon-arrow-right">
                <el-breadcrumb-item :to="{ path: '/development' }">联盟发展历程</el-breadcrumb-item>
                <el-breadcrumb-item>联盟发展历程详情</el-breadcrumb-item>
            </el-breadcrumb>

            <article-detail :artDetail='Detail' :pageType="pageType"></article-detail>

            <return-top></return-top>
        </div>
    </div>
</template>

<script>
import ArticleDetail from '@/components/information/articleDetail.vue'
import ReturnTop from '@/components/returnTop.vue'
export default {
  name: 'developmentDetatil',
  props: {

  },
  components: {
    ArticleDetail,
    ReturnTop

  },
  data () {
    return {
      pageType: 'development',
      Detail: { }
    }
  },
  computed: {

  },
  created () {
    this.getdevelopmentDetatilData()
  },
  mounted () {
    document.documentElement.scrollTop = 0

    this.$parent.activeIndex = '11'
  },
  methods: {
    // 获取联盟发展历程详情数据
    getdevelopmentDetatilData () {
      const dataDetail = JSON.parse(sessionStorage.getItem('detailData'))

      this.Detail = dataDetail
    //   dataDetail.attachment = dataDetail.attachment.split('---').map((item) => {
    //     return item
    //   })
    }
  }
}
</script>

<style scoped lang="less">
.developmentDetatil{
    width:100%;
    min-height: 90vh;
    background-color: #F5F5F5;
    overflow: hidden;
    margin-top: 7px;
}
.Con-developmentDetatil{
    min-height: 972px;
    width: 1200px;
    margin: 0 auto;
    background-color: #fff;
    box-sizing: border-box;
    margin: 13px auto 100px;
    padding-top: 28px;
    border-radius: 8px;
    .tip{
        margin-left: 12px;
    }
    /deep/.el-breadcrumb__inner{
        color: #3f62da  !important;
    }
    /deep/.is-link{
        color: #000 !important;
        text-decoration: underline;
    }
}

</style>
